import { FetchModelResponse } from '@cian/http-api';

import { IValidateAddressWebV3Response1 } from '../../../repositories/geo-suggest/entities/entities/ValidateAddressWebV3Response1';

export const isNewValidateRulesResponse = (
  validateResponse: FetchModelResponse<200, 'json', IValidateAddressWebV3Response1>,
): validateResponse is FetchModelResponse<200, 'json', IValidateAddressWebV3Response1> => {
  return validateResponse.response && 'streetId' in validateResponse.response;
};
